import React, { useEffect, useState } from "react";
import classes from "./MatchLayout.module.css";
import moment from "moment-timezone";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const MatchLayout = ({
  match,
  key,
  fantasy_match_joined,
  prediction_match_joined,
}) => {
  
  const navigate = useNavigate();
  const [time, setTime] = useState(null);
  const [display, setDisplay] = useState("block");

  const { t } = useTranslation();

  const matchTimer = (match_date_time) => {
    try {
      const liveTime = moment();
      const matchTime = moment.utc(match_date_time);
      const timeLeft = moment.duration(matchTime.diff(liveTime));

      if (timeLeft.asMilliseconds() <= 0) {
        console.log("Match has already started.");
        setDisplay("none");
      }
      const hours = Math.floor(timeLeft.asHours());
      const minutes = timeLeft.minutes();
      const seconds = timeLeft.seconds();

      // console.log(`Match starts in ${hours}h ${minutes}m ${seconds}s`);
      // return `${hours}h ${minutes}m ${seconds}s`;
      setTime(`${hours}h ${minutes}m ${seconds}s`);
      // setExpireTime(`${hours}h ${minutes}m ${seconds}s`)
    } catch (error) {
      console.log(error, "errro--");
    }
  };

  useEffect(() => {
    if (display != "none") {
      const intervalId = setInterval(() => {
        matchTimer(match?.match_date_time);
      }, 1000);

      return () => {
        clearInterval(intervalId);
      };
    }
  }, [display]);

  return (
    <div className={classes.match_container} key={key}>
      <div className={classes.match_heading}>
        <p className={classes.match_title}>{match?.league_name}</p>
      </div>
      <div className={classes.match_sub_container}>
        <div className={classes.match_details}>
          <img
            src={match?.home_team_image}
            alt={match?.home_team_name}
            className={classes.team_logo}
          />
          <p className={classes.team_name}>{match?.home_team_name}</p>
        </div>
        <div className={classes.match_details}>
          <p className={classes.match_timer} style={{ display }}>
            {time}
          </p>
          <p className={classes.match_time}>
            {moment
              .utc(match?.match_date_time)
              .local()
              .format("dddd, DD MMM YYYY [at] hh:mm A")}
          </p>
        </div>
        <div className={classes.match_details}>
          <img
            src={match?.away_team_image}
            alt={match?.away_team_name}
            className={classes.team_logo}
          />
          <p className={classes.team_name}>{match?.away_team_name}</p>
        </div>
      </div>

      <div className={classes.buttons_container}>
        {fantasy_match_joined ? (
          <button
            type="button"
            className={classes.fantasy_button}
            onClick={() =>
              navigate("/fantasy-game", {
                state: {
                  match_fixture_id: match?.match_fixture_id,
                },
              })
            }
          >
            {t("16")}
          </button>
        ) : (
          <button
            type="button"
            className={classes.fantasy_button}
            onClick={() =>
              navigate("/create-fantasy-team", {
                state: {
                  match_fixture_id: match?.match_fixture_id,
                },
              })
            }
          >
            {t("17")}
          </button>
        )}

        {
          prediction_match_joined ?
            <button type='button' className={classes.prediction_button}
              onClick={() => {
                navigate("/prediction-game", {
                  state: {
                    match_fixture_id: match?.match_fixture_id
                  }
                })
              }}
            >
              {t("159")}
            </button>
            :
            <button type='button' className={classes.prediction_button}
              onClick={() => {
                navigate("/create-prediction", {
                  state: {
                    match_fixture_id: match?.match_fixture_id
                  }
                })
              }}
            >
              {t("160")}
            </button>
        }
      </div>
    </div>
  );
};

export default MatchLayout;
